import { useState, useEffect } from "react";
import "react-dates/initialize";
import { Container, Row, DropdownButton, Dropdown, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { getProductGroups, getProducts } from "../../fetchers/products";
import { getVendorStats, getScoreStats, getWithTextStats } from "../../fetchers/stats";
import { getVendor } from "../../fetchers/vendor";
import fileDownload from "js-file-download";
import SingleDataTile from "../dashboard/SingleDataTile";
import ScoreDistributionTile from "../dashboard/ScoreDistributionTile";
import _ from "lodash";
import api from '../../services/api';

import Reviews from "../profile/Reviews";
import { useGetVendorId } from "../../hooks/global/User";
import DatePicker from "../global/DatePicker";
import { useSelectLanguage } from "../../hooks/global/Languages";
import { useGetVendor } from "../../hooks/vendors/Vendors";

function ReviewsOverview() {

  const currentDate = moment();
  const thirtyDaysAgo = moment().subtract(30, 'days');
  const {data} = useGetVendor();

  const vendorId = useGetVendorId();
  const { t, i18n } = useTranslation();
  const [reviews, setReviews] = useState("");
  const [vendor, setVendor] = useState("");
  const [group, setGroup] = useState("");
  const [groupId, setGroupId] = useState("");
  const [groupName, setGroupName] = useState("");
  const [product, setProduct] = useState("");
  const [productId, setProductId] = useState("");
  const [productName, setProductName] = useState("");
  const [elements, setElements] = useState([]);
  const [modules, setModules] = useState([]);
  const [averageScore, setAverageScore] = useState(0);
  const [countReviews, setCountReviews] = useState(0);
  const [createdAfterDate, setCreatedAfterDate] = useState(thirtyDaysAgo.valueOf());
  const [createdBeforeDate, setCreatedBeforeDate] = useState(currentDate.valueOf());
  const [startDate, setStartDate] = useState(thirtyDaysAgo);
  const [endDate, setEndDate] = useState(currentDate);
  const [vendorScores, setVendorScores] = useState();
  const [reviewsQuery, setReviewsQuery] = useState(undefined);
  const [withTextSize, setWithTextSize] = useState(0);

  const { selectTextByLanguage } = useSelectLanguage();
  const lng = i18n.language;

  const [params, setParams] = useState();

  useEffect(() => {

    if (data) {
      setVendor(data);
    } 
  }, [data]);

  useEffect(() => {
    const URLparams = new URLSearchParams(window.location.search);
    const selectedModuleId = URLparams.get('selectedModuleId');
    const selectedElementId = URLparams.get('selectedElementId');

    const createdAfter = URLparams.get('createdAfter');
    const createdBefore = URLparams.get('createdBefore');

    if (createdAfter || createdBefore) {
      setCreatedAfterDate(createdAfter);
      setCreatedBeforeDate(createdBefore);
      setStartDate(moment(parseInt(createdAfter, 10)));
      setEndDate(moment(parseInt(createdBefore, 10)));
    }

    const temp = {
      vendorId: vendorId,
      group: selectedModuleId || "ALL",
      product: selectedElementId || "ALL",
      lang: lng.toLocaleUpperCase()
    };
    setParams(temp);
  }, [vendorId]);

  useEffect(() => {
    if (params) {
      getProductGroups(params).then((vendorModules) => {
        if (params.group) {
          setModules(vendorModules);
          const selectedModule = vendorModules.find((q) => q.id === params.group);
          selectedModule ? setNamesForGroups(selectedModule.id, selectTextByLanguage(selectedModule.nametoshow), selectedModule.name) :
            setNamesForGroups("ALL", "", "");
        }
      });
    }
  }, [params, i18n.language]);

  useEffect(() => {
    if (params) {
      getProducts(params).then((vendorElements) => {
        setElements(vendorElements);
        const selectedElement = vendorElements.find((q) => q.id === params.product);
        selectedElement ? setNamesForElements(selectedElement.id, selectedElement.nametoshow, selectedElement.name) : setNamesForElements("ALL", "", "");
      });
    }
  }, [groupId]);

  useEffect(() => {
    if (groupId && productId && vendorId) {

      
      getVendorStats(vendorId, groupId, productId, createdAfterDate, createdBeforeDate)
        .then((vendorScores) => {
          setAverageScore(vendorScores.score);
          setCountReviews(parseInt(vendorScores.count));
        });

      getScoreStats(vendorId, groupId, productId, createdAfterDate, createdBeforeDate)
        .then((vendorScores) => setVendorScores(_.map(vendorScores, "count")));

      getWithTextStats(vendorId, groupId, productId, createdAfterDate, createdBeforeDate)
        .then((reviewTextStats) => setWithTextSize(reviewTextStats));
    }

    const temp = {
      vendorId: vendorId,
      group: groupId === "COMPANY" ? "COMPANY": groupId || "ALL",
      productSourceIds: productId || "ALL",
      companyId: groupId === "COMPANY" && productId !== 'ALL' ? productId : '',
      lang: lng.toLocaleUpperCase(),
      createdAfterDate: createdAfterDate,
      createdBeforeDate: createdBeforeDate,
    }
    setReviewsQuery(temp);

  }, [createdAfterDate, createdBeforeDate, groupId, productId]);


  const setQueryDates = (startDate, endDate) => {
    setCreatedAfterDate(moment.utc(startDate).valueOf());
    setCreatedBeforeDate(moment.utc(endDate).valueOf());
  };

  const setNamesForGroups = (id, name, nametoshow) => {
    setGroupId(id);
    params.group = id;

    setGroup(nametoshow);
    setGroupName(name);
  };

  const getCSVfromResponse = async () => {
    const params = { vendorId: vendorId, createdAfter: createdAfterDate, createdBefore: createdBeforeDate, group: groupId, product: productId === 'ALL' ? '' : productId, lang: lng };
    try {
      const url = '/feedback/csvforfeedback';
      const response = await api.get(url, {
        params,
        responseType: 'blob',
      });

      fileDownload(response.data, 'feedback.xlsx');
    } catch (error) {
      console.error('Error downloading CSV:', error);
    }
  };

  const setNamesForElements = (id, name, nametoshow) => {
    params.product = id;
    setProductId(id);
    setProduct(nametoshow);
    setProductName(name);
  };

  const handleBaseDate = (e) => {
    if (e.startDate || e.endDate) {
      setStartDate(e.startDate);
      setEndDate(e.endDate);
      setQueryDates(e.startDate, e.endDate);
    }
  }

  const hadnleGroupChange = (modul) => {
    params.group = modul.id;
    setNamesForGroups(modul?.id || "COMPANY", selectTextByLanguage(modul.nametoshow), modul.id)
    setNamesForElements("ALL", "", "");
  }


  return (
    <div id="artur-reviewsOverview">
      <Container>
        <Row className="reviewsHeader">
          <div className="col-md-12">
            <h2>{t("admin.reviews.rateReview")} {vendor.name}</h2>
          </div>
        </Row>
        <Row className="reviewsFilter mb-4">
          <div className="col-md-4">
            <p>{t("admin.reviews.modulRate")}</p>
            <div className="dropdownWrap dropdownWrap-wide clearfix">
              <DropdownButton id="selectModule" title={groupName || t("admin.common.allModules")}>
                <Dropdown.Item eventKey="1" role="menuitem" onClick={() => setNamesForGroups("ALL", t('admin.common.allModules'), "ALL")}>
                  {t('admin.common.allModules')}
                </Dropdown.Item>
                {modules.length > 0 && (
                  modules.map((modul, index) => (
                    <Dropdown.Item
                      key={modul.id}
                      eventKey={index + 2}
                      role="menuitem"
                      onClick={() => hadnleGroupChange(modul)}
                    >
                      {selectTextByLanguage(modul.nametoshow)}
                    </Dropdown.Item>
                  ))
                )}
              </DropdownButton>
            </div>
          </div>
          <div className="col-md-4">
            <p>{t("admin.reviews.eleRate")}</p>
            <div className="dropdownWrap dropdownWrap-wide clearfix">
              <DropdownButton id="selectModuleItem" title={productName || t("admin.common.allElements")}>
                <Dropdown.Item eventKey="1" role="menuitem" onClick={() => setNamesForElements("ALL", "", "")}>
                  {t("admin.common.allElements")}
                </Dropdown.Item>
                {elements.map((element, index) => (
                  <Dropdown.Item
                    key={element.id}
                    eventKey={index + 2}
                    role="menuitem"
                    onClick={() => setNamesForElements(element?.id || "ALL", element.nametoshow, element.name)}
                  >
                    {element.nametoshow}
                  </Dropdown.Item>
                ))}
              </DropdownButton>
            </div>
          </div>
          <Col md={4} className="adminReportDropdown adminReportDropdownAirbnb">
            <p>{t("admin.common.timePeriod")}</p>
            <div className="datePickerWrap datePickerWrapDesktop">
              <DatePicker onSelect={handleBaseDate} date={{ startDate, endDate }} />
            </div>
          </Col>
        </Row>
        <Row className="reviewsTiles">
          <div className="col-md-4">
            <SingleDataTile className={"tile tileOrange"} value={averageScore} decimalPlaces={1} title={t("admin.common.avgRat")} />
          </div>
          <div className="col-md-4">

            <SingleDataTile className={"tile tileYellow"} value={countReviews} decimalPlaces={1} title={t("admin.common.colRev", { count: Math.round(countReviews) })} />

          </div>
          <div className="col-md-4">
            {vendorScores && (
              <ScoreDistributionTile
                showHeader={false}
                showTitleTile={false}
                rate1Count={_.parseInt(vendorScores[0])}
                rate2Count={_.parseInt(vendorScores[1])}
                rate3Count={_.parseInt(vendorScores[2])}
                rate4Count={_.parseInt(vendorScores[3])}
                rate5Count={_.parseInt(vendorScores[4])}
              />
            )}
          </div>
        </Row>
        <Row className="reviewsContent">
          <Col md={12}>
            <a className="exportCSV" onClick={getCSVfromResponse}>{t("admin.common.CSV")}</a>
            {countReviews && vendorScores ? (
              <Reviews
                scores={vendorScores}
                withTextSize={withTextSize.count}
                searchReviewsQuery={reviewsQuery}
                editable={true}
                elementDetailsVisible={true}
                key={reviews.id}
                pageSize={20}
                countReviews={countReviews}
              />
            ) : (
              <div className="noRatings">{t("admin.common.noData")}</div>
            )}
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default ReviewsOverview;
